<template lang="jade" src="./target.jade"></template>

<script>
  export default {
    data () {
      return {
        animated_headline: "https://s3-us-west-1.amazonaws.com/db13/1440/hdr.svg",
        title: 'I am your Hardware',
        copy: 'I am hungry to consume: vibrant, intelligent, magnificent detail; the artist’s vision; real-time; the most advanced technology… the goods. I don’t want restrictions: to pay a price; to have a proprietary gate keeper. I want it all: free and compatible in every way. A good device is an open device. Receptive and engineered to elevate. HDR. Heart-stopping Definitive Reality? High Dynamic Range! What you make should never lack brilliance and always, always inspire you to…',
        lastword: 'ADAPT',
        video: 'https://s3-us-west-1.amazonaws.com/db13/1440/ce-manufacturers.mp4',
        back_link: '/content-distributors',
        forward_link: '/ce-distributors',
        back_img: 'imgs/icons/back-arrow.svg',
        forward_img: 'imgs/icons/forward-arrow.svg',
        back: 'imgs/icons/back-arrow.svg',
        vTransparency: {
          opacity: '0.7'
        }
      }
    }
  }
</script>

<style lang="sass?indentedSyntax" scoped>

  @import "../../_sass/utilities/_utilities.sass"

  h1,
  span.beleive
    color: $orange!important

</style>


/** WEBPACK FOOTER **
 ** ce-manufacturers.vue?75c60ad3
 **/